<template>
    <div style="height: 100%; background: #f0f8ffa6">
        <el-tooltip class="item" content="上一页" effect="light" placement="bottom">
            <img @click="backs()"
                style="float: left; margin: 8px; cursor: pointer; position: absolute; width: 26px; top: 10px; right: 87px; color: #fff;"
                src="../../static/img/fh.png" alt="" />
        </el-tooltip>

        <el-tooltip class="item" content="首页" effect="light" placement="bottom">
            <img src="../../static/img/sy.png" @click="back()" alt=""
                style="float: left; margin: 8px; cursor: pointer; position: absolute; width: 28px; top: 9px; right: 37px; color: #fff;" />
        </el-tooltip>
        <ul style=" display: flex; justify-content: space-around; width: 100%; padding-top: 10px; height: 255px;">
            <li class="top-block">
                <p style="display: flex; align-items: center; margin: 6%">
                    <el-avatar
                        style="background: #409eff; width: 55px; height: 55px; line-height: 52px; font-size: 28px;"
                        icon="el-icon-user-solid"></el-avatar>
                    <span style="margin: 0px 10px; font-size: 24px; font-weight: 600">{{ users }}</span>
                </p>
                <p style="margin-left: 32px; font-size: 16px">
                    <span style="color: #909399">上次登陆时间：</span>{{ lastLogin }}
                </p>
                <p style="margin: 10px 32px; font-size: 15px; cursor: pointer; color: #409eff;">
                    <span @click="dialogVisibles = true">修改密码</span>
                </p>
            </li>
            <li class="top-block" style="width: 25%; min-width: 362px" v-if="$root.clientType === 0">
                <h3 style="padding: 5px">账号信息</h3>
                <div style="display: flex; margin: 12px 0; justify-content: space-around">
                    <p style="text-align: center">
                        <span style="font-size: 16px; color: #909399">现金余额</span>
                        <br /><span style="font-size: 20px; color: #000; font-weight: 700">￥{{ cashBalance }}</span>
                    </p>
                    <p style="text-align: center">
                        <span style="font-size: 16px; color: #909399">可开票金额</span>
                        <br /><span style="font-size: 20px; color: #000; font-weight: 700">￥{{ InvoicableAmount }}</span>
                    </p>
                    <p style="text-align: center; cursor: pointer">
                        <span style="font-size: 16px; color: #909399">代金券</span>
                        <br /><span style="font-size: 20px; color: #000; font-weight: 700">0</span>
                    </p>
                </div>
                <el-button v-if="username != 'admin'" style="margin: 10px 2%; background-image: linear-gradient(26deg, #409eff 0%, #75f735 100%); border: #fff;" type="primary"
                    @click="true ? goup() : (dialogVisible3 = true)">
                    充值
                    <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
                <el-button class="kaip" style="margin: 10px 2%; border: #fff;" @click="goKP()" type="primary">发票管理</el-button>
                <el-button style="margin: 10px 2%; border: #fff;" type="primary" @click="$router.push({ path: '/payrecord' })" v-if="username == 'admin'">交费记录</el-button>
                <p @click="goddlist()" style=" cursor: pointer; font-size: 18px; padding: 18px 2%; display: flex; float: right; align-items: center;">
                    我的订单
                    <i style="font-size: 28px" class="el-icon-shopping-cart-full"></i>
                </p>
            </li>
            <li class="top-block" :style="{ width: $root.clientType === 0 ? '35%' : '74%', 'min-width': '427px' }">
                <h3 style="padding: 5px">账号权限</h3>
                <div style="display: flex; margin: 12px 0; justify-content: space-around">
                    <p style="text-align: center">
                        <span style="font-size: 16px; color: #909399">会员级别</span>
                        <br />
                        <span v-if="userType == 3"
                            style=" font-size: 20px; background: -webkit-linear-gradient(#f5e93f, #f59505); -webkit-background-clip: text; -webkit-text-fill-color: transparent; font-weight: 700;">
                            VIP用户
                        </span>
                        <span v-if="userType == 0" style="font-size: 20px; font-weight: 700">管理员</span>
                        <span v-if="userType == 1" style="font-size: 20px; font-weight: 700">普通用户</span>
                        <span v-if="userType == 2" style="font-size: 20px; font-weight: 700">高级用户</span>
                        <span v-if="userType == 4" style="font-size: 20px; font-weight: 700">测试用户</span>
                    </p>
                    <p style="text-align: center">
                        <span style="font-size: 16px; color: #909399">使用权限到期时间</span>
                        <br /><span style="font-size: 20px; color: #000; font-weight: 700">{{ endTime }}</span>
                    </p>
                    <p style="text-align: center">
                        <span style="font-size: 16px; color: #909399"> 剩余次数</span>
                        <br /><span style="font-size: 20px; color: #000; font-weight: 700">{{ remainNum }}</span>
                    </p>
                </div>
                <el-button v-if="$root.clientType === 0"
                    style="margin: 10px 0 0 2vw; border-color: #fff; background-image: linear-gradient(57deg, #f5e93f 0%, #ff922c 100%);"
                    type="warning" @click="goshengji()">
                    选择服务
                    <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
                <span v-if="userType != 1 && userGenre != 1 && $root.clientType != 2" class="shuom bgs" @click="goAPI()">API调用说明</span>
            </li>
        </ul>
        <el-tag style="width: 98%; text-align: left; font-size: 18px; height: 43px; line-height: 40px; margin-bottom: 10px;" type="warning">
            15日内检测记录
        </el-tag>
        <div style="width: 100%; height: 800px; padding: 11px 40px; background: #fff" id="data2"></div>
        <el-tag style="width: 98%; text-align: left; font-size: 18px; height: 43px; line-height: 40px; margin-bottom: 10px;">
            <el-button type="primary" plain @click="DictionaryDefinition.show = false" style="border: none;">使用记录</el-button>
            <el-button :disabled="!openWordDefinition" type="primary" plain style="border: none;" @click="DictionaryDefinition.show = true">词语释义</el-button>
        </el-tag>
        <div v-if="!DictionaryDefinition.show" style="padding: 40px; margin: 0 auto; background: #fff">
            <div style="text-align: left; margin: 0 0 37px 12px">
                <el-select v-if="$root.clientType == 0" v-model="selRecType" style="width: 100px;">
                    <el-option label="文本" :value="1"></el-option>
                    <el-option label="图片" :value="2" v-if="userType === 0 || userType === 3"></el-option>
                    <el-option label="视频" :value="3" v-if="userType === 0 || userType === 3"></el-option>
                    <el-option label="音频" :value="4" v-if="userType === 0 || userType === 3"></el-option>
                </el-select>
                <el-date-picker style="width: 392px" v-model="selDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                <el-input placeholder="搜索结果词" style="width: 200px;" v-model="selWord"></el-input>
                <el-input v-show="user == 'admin'" style="width: 200px; margin: 0 0 0 15px" v-model="inputs" placeholder="请输入您要搜索的用户"></el-input>
                <el-button type="primary" icon="el-icon-search" style="margin: 0 0 0 15px" @click="btnSelRecords()">搜索</el-button>
                <el-button @click="btnSelRecords(2)">显示全部</el-button>
            </div>
            <el-table v-loading="loading" :data="tableData" id="tab" border style="width: 100%">
                <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
                <el-table-column label="资源" align="center" v-if="tableData.length > 0 && tableData[0].rectype != 1">
                    <template slot-scope="scope">
                        <img v-if="scope.row.rectype == 2" :src="scope.row.fileUrl" alt="" style="max-height: 100px;">
                        <video v-else-if="scope.row.rectype == 3" :src="scope.row.fileUrl" style="max-height: 100px;"></video>
                        <img v-else-if="scope.row.rectype == 4" src="/static/img/audio.png" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="用户" align="center"></el-table-column>
                <el-table-column prop="nickname" label="用户名称" align="center"></el-table-column>
                <el-table-column prop="checkTime" label="送审时间" align="center"></el-table-column>
                <el-table-column label="审核状态" align="center" v-if="tableData.length > 0 && tableData[0].rectype != 1">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'PROVISIONING'">排队中</span>
                        <span v-if="scope.row.status == 'PROCESSING'">审核中</span>
                        <span v-if="scope.row.status == 'FINISHED'">审核完成</span>
                        <span v-if="scope.row.status == 'ERROR'">审核失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="result" label="审核结果" align="center">
                    <template slot-scope="scope">
                        <template v-if="('problem' in scope.row || 'result' in scope.row)">
                            <span v-if="scope.row.rectype == 1 && scope.row.result > 0">疑似问题：<span style="color: #66b1ff">{{ scope.row.result }}个</span></span>
                            <span v-else-if="scope.row.rectype != 1 && parseInt(scope.row.problem) > 0">疑似问题：<span style="color: #66b1ff">{{ scope.row.problem }}个</span></span>
                            <span v-else style="color: #17c554">通过</span>
                        </template>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="result" label="原文比对" align="center"><template slot-scope="scope">
                        <el-button @click="detailData(scope.row)">查看详情</el-button>
                        <el-button type="danger" @click="deletes(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin: 28px 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="currentPage4" :page-size="10" layout="total, prev, pager, next" :total="nums">
            </el-pagination>
        </div>
        <div v-else style="min-height: 30vh; width: 100%; padding-bottom: 100px;">
            <div>
                <el-input v-model="DictionaryDefinition.word" style="display: inline-block; width: 200px;"></el-input>
                <el-button @click="queryWordDefinition" v-loading="DictionaryDefinition.queryLoading">查询</el-button>
            </div>
            <div style="width: 50%; margin: 0 auto; border: 1px solid #ccc; border-radius: .5em; min-height: 200px; margin-top: 10px; padding: 20px;">
                <div v-if="DictionaryDefinition.definition.length > 0">
                    <p>释义：</p>
                    <p>{{ DictionaryDefinition.definition }}</p>
                </div>
                <div v-else-if="DictionaryDefinition.content.length > 0">
                    <p class="cidian-item">词语：{{ DictionaryDefinition.word }}&nbsp;&nbsp;&nbsp;&nbsp;拼音：{{ DictionaryDefinition.pinyin }}</p>
                    <p class="cidian-item">近义词：{{ DictionaryDefinition.jin }}</p>
                    <p class="cidian-item">反义词：{{ DictionaryDefinition.fan }}</p>
                    <p class="cidian-item-title">释义：</p><div class="cidian-content" v-html="DictionaryDefinition.content"></div>
                    <p class="cidian-item-title">例子：</p><div class="cidian-content" v-html="DictionaryDefinition.example"></div>
                </div>
            </div>
        </div>
        <!-- 这里使用v-if强制重新生成dialog，不然这块只是隐藏，第二次打开的时候，无法触发mounted方法 -->
        <el-dialog title="审核结果记录" :visible.sync="dialogVisible" :before-close="handleCloses" width="70%">
            <audit-result ref="audit" style="height: 65vh;"></audit-result>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="资源审核结果" :visible.sync="dlgMediaResult.show" width="85%">
            <media-audit-result ref="mediaResult" style="min-height: 450px; max-height: 60vh; overflow: scroll;"></media-audit-result>
            <span slot="footer"></span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" width="50%" id="txte" style="text-align: left">
            <div slot="title" v-show="ttle == '费用说明'" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-wallet" style="color: #ff8d00; font-size: 20px; margin-right: 6px"></i>
                <span class="title-text">费用说明</span>
                <div class="button-right">
                    <span class="title-close" @click="handleClose"></span>
                </div>
            </div>
            <div v-show="ttle == '费用说明'" class="pps" style="margin: 10px; padding: 0 15px">
                <h3 style="color: cornflowerblue">个人用户：</h3>
                <p>用户级别：标准用户 / 高级用户 / VIP用户</p>
                <p>
                    服务方式：按时间/按次数 【<span style="color: red">最少时间3个月，最少次数1000次</span>】
                </p>
                <br />
                <h3 style="color: cornflowerblue">费用计算：</h3>
                <p>标准用户：3000.00/月 1.00/次（服务范围：基础模式、增强模式）</p>
                <p>
                    高级用户：5000.00/月
                    2.00/次（服务范围：基础模式、增强模式、疑似识别、提供API）
                </p>
                <p>
                    VIP用户 ：6000.00/月
                    3.00/次（服务范围：基础模式、增强模式、智能模式、疑似识别、提供API）
                </p>
                <br />
                <h3 style="color: cornflowerblue">单位用户：</h3>
                <p>用户级别：标准用户 / 高级用户 / VIP用户</p>
                <p>
                    服务方式：按时间/按次数 【<span style="color: red">最少时间3个月，最少次数5000次</span>
                    】
                </p>
                <p>用户数量：支持多用户</p>
                <br />
                <h3 style="color: cornflowerblue">费用计算：</h3>
                <p>标准用户：3000.00/月 1.00/次 （服务范围：基础模式、增强模式）</p>
                <p>
                    高级用户：5000.00/月 2.00/次
                    （服务范围：基础模式、增强模式、疑似识别、提供API）
                </p>
                <p>
                    VIP用户 ：6000.00/月 3.00/次
                    （服务范围：基础模式、增强模式、智能模式、疑似识别、提供API）
                </p>
                <p>用户授权：2000.00/个</p>
            </div>

            <div slot="title" v-show="ttle == '会员级别说明'" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-user-solid" style="color: #ff8d00; font-size: 20px; margin-right: 6px"></i>
                <span class="title-text">会员级别</span>
                <div class="button-right">
                    <span class="title-close" @click="handleClose"></span>
                </div>
            </div>
            <div v-show="ttle == '会员级别说明'" style="font-size: 15px; padding: 0 20px 16px; line-height: 25px; border: 1px solid #ccc; color: rgb(96 94 94);">
                <p style="font-size: 18px; margin: 22px 0 0 0; line-height: 35px; color: #5fcd77;">普通用户：</p>
                在线检测2000字以内的文章，使用基础模式、增强模式两种识别方法。
                <p style="font-size: 18px; line-height: 35px; margin: 22px 0 0 0; color: #3092f7;">高级用户：</p>
                在线检测文章的字数不限，开启导出报告功能、API接口功能。使用基础模式、增强模式两种识别方法。
                <p style="font-size: 18px; line-height: 35px; margin: 22px 0 0 0; color: #e6a23c;">VIP用户：</p>
                在线检测文章的字数不限，开启导出报告功能、API接口功能。使用基础模式、增强模式、智能识别模式。识别范围更广泛，可检测输入性错误，进行疑似判定。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible3" width="350px" style="text-align: left">
            <div slot="title" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-user-solid" style="color: #ff8d00; font-size: 17px; margin-right: 6px"></i>
                <span class="title-text">功能</span>
                <div class="button-right">
                    <span class="title-close" @click="handleClose"></span>
                </div>
            </div>
            <div style="font-size: 16px; line-height: 25px">暂未开通，敬请期待！</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog style="text-align: left" :visible.sync="dialogVisibles" @close="quxiao()" width="520px">
            <div slot="title" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-lock"></i>
                <span class="title-text">修改密码</span>
                <div class="button-right">
                    <span class="title-close" @click="handleClose"></span>
                </div>
            </div>
            <div style="width: 70%; height: 150px; line-height: 68px; margin: 0 auto">
                <el-input type="password" v-model="ruleForm.pass1" autocomplete="off" show-password
                    placeholder="请输入旧密码">
                    <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
                <el-input type="password" v-model="ruleForm.pass2" autocomplete="off" show-password
                    placeholder="请输入新密码（6-18位数字或英文字符组合）">
                    <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="quxiao()">取 消</el-button>
                <el-button type="primary" @click="xiugaimm()">确定修改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from "echarts";
import AuditResult from './DocAudit.vue'
import MediaAuditResult from './MediaAuditResult.vue'
export default {
    components: { AuditResult, MediaAuditResult },
    data() {
        return {
            cashBalance: 0,
            InvoicableAmount: 0,
            activeName: "错别字",
            contents: "",
            nums: 0,
            selDateRange: "",
            selWord: '',
            currentPage4: 1,
            value: "",
            users: "",
            data1: [],
            data2: [],
            data3: [],
            data4: [],
            tableData1: [],
            tableData2: [],
            tableData3: [],
            tableData4: [],
            user: "",
            inputs: "",
            remainNum: "",
            lastLogin: "",
            endTime: "",
            selRecType: 1,
            list: [],
            dialogVisible: false,
            dialogVisible2: false,
            dialogVisible3: false,
            tableData: [],
            ttle: "",
            startDate: "",
            endDate: "",
            loading: false,
            dialogVisibles: false,
            ruleForm: {
                pass1: "",
                pass2: "",
            },
            dlgAuditResult: {
                auditText: '',
                stopList: [],
                suspectList: [],
                senList: [],
                typoList: []
            },
            // 图片视频审核结果查看
            dlgMediaResult: {
                show: false,
                uuid: ''
            },
            DictionaryDefinition: {
                show: false,
                queryLoading: false,
                word: '',
                definition: '',
                pinyin: '',     // 词语拼音
                content: '',    // 解释内容
                example: '',    // 例子
                jin: '',        // 近义词
                fan: ''         // 反义词
            }
        };
    },
    methods: {
        backs() { window.history.go(-1) },
        back() { this.$router.push({ path: "/home" }) },
        goAPI() { this.$router.push({ path: "/apis" }) },
        goup() { this.$router.push({ path: "/topUp" }) },
        goKP() {
            if (sessionStorage.getItem("username") == 'admin') {
                this.$router.push({ path: '/invoice-ctrl' })
            } else {
                this.$router.push({ path: "/invoice" });
            }
        },
        getTime(time) {
            var date = new Date(time);
            var y = date.getFullYear();
            var m =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            return y + "-" + m + "-" + d;
        },
        quxiao() {
            this.dialogVisibles = false;
            this.ruleForm = {
                pass1: "",
                pass2: "",
            };
        },
        btnSelRecords(v) {
            this.currentPage4 = 1
            if (v == 2) {
                this.startDate = "";
                this.endDate = "";
                this.selDateRange = "";
                this.inputs = "";
            } else if (this.selDateRange == "") {
                this.startDate = "";
                this.endDate = "";
                console.log(this.selDateRange, 11);
            } else {
                this.startDate = this.getTime(this.selDateRange[0]);
                this.endDate = this.getTime(this.selDateRange[1]);
            }

            this.getRecordList();
        },
        dialogs(v) {
            this.ttle = v;
            this.dialogVisible2 = true;
        },
        goshengji() {
            this.$router.push({
                path: "/recharge",
            });
        },
        changeStr(str, index, nn, changeStr) {
            return (
                str.substr(index, nn) + changeStr + str.substr(nn + changeStr.length)
            );
        },
        handleClose(done) {
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => { });
        },
        handleClick(tab, event) {
            if (this.activeName == "禁用词") {
                this.list = this.data1;
            } else if (this.activeName == "疑似错别字") {
                this.list = this.data2;
            } else if (this.activeName == "敏感词") {
                this.list = this.data3;
            } else {
                this.list = this.data4;
            }
        },
        handleCloses() {
            this.dialogVisible = false;
        },
        detailData(val) {
            console.log(val)
            if (val.rectype == 1) {
                this.dialogVisible = true
                // 第一次打开对话框，需要有一定的时间来生成对话框代码，这时组件可能还没创建，不能直接就执行组件内的方法
                setTimeout(() => {
                    console.log(this.$refs.audit)
                    this.$refs.audit.setAuditTxt(val.content)
                    this.$refs.audit.setAuditResult(
                        val.description.typoList,
                        val.description.suspectList,
                        val.description.stopList,
                        val.description.senList,
                        val.description.dscontent
                    )
                }, 200);
                return
            } else {
                this.dlgMediaResult.show = true
                setTimeout(() => {
                    this.$refs.mediaResult.setResLink(val.rectype, val.fileUrl)
                    // 请求审核结果
                    this.$refs.mediaResult.setPageLoading(true)
                    this.$axios.post('/cmsMateService/login.do?method=achieveAiCheckResultList', {
                        username: sessionStorage.getItem('username'),
                        uuid: val.uuid
                    }).then(res => {
                        if (res.status !== 200 || parseInt(res.data.result) !== 200) {
                            this.$message({ type: 'warning', message: '审核结果获取失败' })
                        } else {
                            if (res.data.info.list != undefined) {
                                this.$refs.mediaResult.setAuditResult(res.data.info.list)
                            } else {
                                this.$refs.mediaResult.setAuditResult([])
                            }
                        }
                        this.$refs.mediaResult.setPageLoading(false)
                    }).catch(() => {
                        this.$message({ type: 'warning', message: '审核结果获取异常' })
                        this.$refs.mediaResult.setPageLoading(false)
                    })
                }, 200)
            }
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        gettxt() {
            this.$nextTick(() => {
                document.getElementById("txts").innerHTML = this.value;
            });
        },
        deletes(val) {
            console.log(val);
            this.$confirm("您确定删除此条记录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                if (val.rectype === 1) {
                    this.$axios.post("/cmsMateService/login.do?method=deleteCheckLog", {
                        username: this.user,
                        logId: val.logId,
                    }).then((res) => {
                        console.log(res.data.result);
                        if (res.data.result == 200) {
                            this.$message({ type: "success", message: "删除成功!" });
                            this.getRecordList();
                        } else {
                            this.$message({ message: res.data.message });
                        }
                    }).catch((error) => {
                        this.loading = false;
                        console.log(error.message);
                    });
                } else {
                    this.$axios.post('/cmsMateService/login.do?method=deleteFileCheckLog', {
                        username: this.user,
                        uuid: val.uuid
                    }).then(res => {
                        if (res.status !== 200 || parseInt(res.data.result) !== 200) {
                            this.$message({ type: 'warning', message: '删除失败' })
                        } else {
                            this.$message({ type: 'success', message: '删除成功' })
                            this.getRecordList()
                        }
                    }).catch(() => {
                        this.$message({ type: 'warning', message: '删除异常' })
                    })
                }
            }).catch(() => {
                this.$message({ type: "info", message: "已取消删除" });
            });
        },
        getData2() {
            var a = [];
            this.$axios.post("/cmsMateService/login.do?method=achieve15dayCheckLog", {
                username: this.user,
                flag: 1,
            }).then((res) => {
                a = res.data.info;
                this.getData3(a);
            }).catch((error) => {
                console.log(error.message);
            });
        },
        getData3(a) {
            var b = [];
            this.$axios.post("/cmsMateService/login.do?method=achieve15dayCheckLog", {
                username: this.user,
                flag: 2,
            }).then((res) => {
                b = res.data.info;
                this.getdata(a, b);
            }).catch((error) => {
                console.log(error.message);
            });
        },
        getdata(a, b) {
            var chartDom = document.getElementById("data2");
            var myChart = echarts.init(chartDom);
            var option;

            const dateList = [];
            a.forEach(function (item) {
                dateList.push(item.date);
            });
            const valueList = [];
            a.forEach(function (item) {
                valueList.push(item.num);
            });

            const dateList2 = b.map(function (item) {
                return item.date;
            });
            const valueList2 = b.map(function (item) {
                return item.num;
            });
            option = {
                // Make gradient line here
                visualMap: [
                    {
                        show: false,
                        type: "continuous",
                        seriesIndex: 0,
                        min: 0,
                        max: 400,
                    },
                    {
                        show: false,
                        type: "continuous",
                        seriesIndex: 1,
                        dimension: 0,
                        min: 0,
                        max: dateList.length - 1,
                    },
                ],
                title: [
                    {
                        left: "center",
                        text: "检测次数",
                    },
                    {
                        top: "55%",
                        left: "center",
                        text: "检测字数",
                    },
                ],
                tooltip: {
                    trigger: "axis",
                },
                xAxis: [
                    {
                        data: dateList,
                    },
                    {
                        data: dateList2,
                        gridIndex: 1,
                    },
                ],
                yAxis: [
                    {},
                    {
                        gridIndex: 1,
                    },
                ],
                grid: [
                    {
                        bottom: "60%",
                    },
                    {
                        top: "60%",
                    },
                ],
                series: [
                    {
                        type: "line",
                        showSymbol: false,
                        data: valueList,
                    },
                    {
                        type: "line",
                        showSymbol: false,
                        data: valueList2,
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                    },
                ],
            };

            option && myChart.setOption(option);

            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        checkeds(val) {
            console.log(val, "!!!!");
            var value = "";
            value = document.getElementById("txts").innerHTML;

            name = this.activeName;
            var name2 = "";
            if (this.activeName == "错别字") {
                name2 = "建议修改";
            } else if (this.activeName == "敏感词") {
                name2 = "敏感词类型";
            }
            var dom = "." + val.id;
            var nums = $("." + val.id).length - 1;
            this.num++;

            $(".log").remove();
            $("span").css("border", "none");
            if (this.activeName == "错别字") {
                val.index = val.index.toString();
                var indexs = val.index.split(",");
                for (let i = 0; i < indexs.length; i++) {
                    var ids = $("." + "data4" + indexs[i]).length;
                    for (let index = 0; index < ids; index++) {
                        if (
                            $("." + "data4" + indexs[i])
                                .eq(index)
                                .text() == ""
                        ) {
                            return;
                            //trim()方法是去空格，$.trim()函数删除提供字符串的所有换行符,空格（包括非中断空格），开始和结束tab。如果这些空白字符在字符串中间发生时，它们将被保留。
                        } else {
                        }
                    }

                    if (indexs.length <= 1) {
                        $("." + val.id).css({
                            "border-top": "3px solid #00bcd4",
                            "border-bottom": "3px solid #00bcd4",
                            position: "relative",
                        });
                        $("." + val.id)
                            .eq(0)
                            .css({
                                "border-left": "3px solid #00bcd4",
                            });
                        $("." + val.id + ":last").css({
                            "border-right": "3px solid #00bcd4",
                        });

                        $("." + val.id)
                            .eq(0)
                            .append(
                                '<div class="log" style="display: block;width: 250px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                                name +
                                "：" +
                                val.word +
                                "</li></ul></div>"
                            );
                    } else {
                        $("." + "data4" + indexs[i]).css({
                            "border-top": "1.5px solid #00bcd4",
                            "border-bottom": "1.5px solid #00bcd4",
                            position: "relative",
                        });

                        $("." + "data4" + indexs[i])
                            .eq(0)
                            .css({
                                "border-left": "3px solid #00bcd4",
                            });
                        $("." + "data4" + indexs[i] + ":last").css({
                            "border-right": "3px solid #00bcd4",
                        });
                        // $("." + val.id).wrapAll("<div style='border: 3px solid #f23325;display: inline;padding: 3px 0;'></div>");
                        $("." + "data4" + indexs[i])
                            .eq(0)
                            .append(
                                '<div class="log" style="display: block;width: 250px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                                name +
                                "：" +
                                val.word +
                                "</li></ul></div>"
                            );
                        // .siblings()
                        // .children(".log")
                        // .remove();
                    }
                }
                $(".drop-con").append(
                    "<li class='text1'>" + name2 + "：" + val.trueword + "</li> "
                );
            } else if (this.activeName == "疑似错别字") {
                val.index = val.index.toString();
                var indexs = val.index.split(",");
                for (let i = 0; i < indexs.length; i++) {
                    var ids = $("." + "data2" + indexs[i]).length;
                    for (let index = 0; index < ids; index++) {
                        if (
                            $("." + "data2" + indexs[i])
                                .eq(index)
                                .text() == ""
                        ) {
                            return;
                            //trim()方法是去空格，$.trim()函数删除提供字符串的所有换行符,空格（包括非中断空格），开始和结束tab。如果这些空白字符在字符串中间发生时，它们将被保留。
                        } else {
                        }
                    }

                    console.log(ids, val.word.length);

                    if (indexs.length <= 1) {
                        $("." + val.id).css({
                            "border-top": "3px solid #f23325",
                            "border-bottom": "3px solid #f23325",
                            position: "relative",
                        });
                        $("." + val.id)
                            .eq(0)
                            .css({
                                "border-left": "3px solid #f23325",
                            });
                        $("." + val.id + ":last").css({
                            "border-right": "3px solid #f23325",
                        });

                        $("." + val.id)
                            .eq(0)
                            .append(
                                '<div class="log" style="display: block;width: 250px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                                name +
                                "：" +
                                val.word +
                                "</li></ul></div>"
                            );
                    } else {
                        $("." + "data2" + indexs[i]).css({
                            "border-top": "1.5px solid #f23325",
                            "border-bottom": "1.5px solid #f23325",
                            position: "relative",
                        });

                        $("." + "data2" + indexs[i])
                            .eq(0)
                            .css({
                                "border-left": "3px solid #f23325",
                            });
                        $("." + "data2" + indexs[i] + ":last").css({
                            "border-right": "3px solid #f23325",
                        });
                        // $("." + val.id).wrapAll("<div style='border: 3px solid #f23325;display: inline;padding: 3px 0;'></div>");
                        $("." + "data2" + indexs[i])
                            .eq(0)
                            .append(
                                '<div class="log" style="display: block;width: 250px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                                name +
                                "：" +
                                val.word +
                                "</li></ul></div>"
                            );
                        // .siblings()
                        // .children(".log")
                        // .remove();
                    }
                }
            } else if (this.num <= nums && $(".log").length <= 0) {
                $("." + val.id)
                    .eq(this.num)
                    .css({ border: "3px solid #f23325", position: "relative" })
                    .siblings()
                    .css("border", "none");

                $("." + val.id)
                    .eq(this.num)
                    .append(
                        '<div class="log" style="display: block;width: 250px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                        name +
                        "：" +
                        val.word +
                        "</li></ul></div>"
                    )
                    .siblings()
                    .children(".log")
                    .remove();
                if (this.activeName == "错别字") {
                    $(".drop-con").append(
                        "<li class='text1'>" + name2 + "：" + val.trueword + "</li> "
                    );
                } else if (this.activeName == "敏感词") {
                    $(".drop-con").append(
                        "<li class='text1'>" + name2 + "：" + val.type + "</li> "
                    );
                }
            } else {
                this.num = -1;
            }
        },
        hidden() {
            $(".log").remove();
            $("span").css("border", "none");
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.currentPage4 = val;
            this.getRecordList();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage4 = val;
            this.getRecordList();
        },
        getRecordList() {
            this.loading = true; this.tableData = []
            if (this.selRecType === 1) {
                this.$axios.post("/cmsMateService/login.do?method=achieveCheckLog", {
                    username: this.user,
                    page: this.currentPage4,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    searchuser: this.inputs,
                    searchword: this.selWord
                }).then((res) => {
                    this.loading = false;
                    if (res.data.result != 200) {
                        Message.error(res.data.err);
                        return;
                    }

                    this.remainNum = res.data.remainNum;
                    this.nums = res.data.num;
                    for (var i = 0; i < res.data.info.length; i++) {
                        var item = res.data.info[i]
                        item.rectype = 1
                        this.tableData.push(item)
                    }
                    console.log(this.tableData);
                }).catch((error) => {
                    this.loading = false;
                    console.log(error.message);
                });
            } else {
                var opType = 1
                if (this.selRecType === 2) opType = 1       // 图片
                else if (this.selRecType === 3) opType = 3  // 视频
                else if (this.selRecType === 4) opType = 2  // 音频
                this.$axios.post('/cmsMateService/login.do?method=achieveFileCheckLog', {
                    username: this.user,
                    page: this.currentPage4,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    searchuser: this.inputs,
                    searchword: this.selWord,
                    type: opType
                }).then(res => {
                    this.loading = false
                    if (res.status !== 200 || parseInt(res.data.result) !== 200) {
                        this.$message({ type: 'warning', message: '获取记录失败' })
                    } else {
                        this.nums = parseInt(res.data.num)
                        // username,status,nickname,problem,checkTime,uuid
                        // this.tableData = res.data.info
                        for (var i = 0; i < res.data.info.length && i < 100; i++) {
                            var item = res.data.info[i]
                            item.rectype = this.selRecType
                            this.tableData.push(item)
                        }
                    }
                }).catch(() => {
                    this.loading = false
                    this.$message({ type: 'warning', message: '获取记录异常' })
                })
            }
        },
        xiugaimm() {
            if (this.ruleForm.pass1 == "" || this.ruleForm.pass2 == "") {
                this.$message({
                    message: "填写密码不能为空！",
                    type: "error",
                });
                return;
            }

            if (this.ruleForm.pass2.length < 6 || this.ruleForm.pass2.length > 18) {
                this.$message({
                    message: "请输入6-18位数字或英文字符组合！",
                    type: "error",
                });
                return;
            }

            var pass1 = this.$md5(this.ruleForm.pass1);
            var pass2 = this.$md5(this.ruleForm.pass2);

            this.$axios
                .post(
                    "/cmsMateService/login.do?method=updatePassword",
                    {
                        username: sessionStorage.getItem("username"),
                        old_password: pass1.toUpperCase(),
                        new_password: pass2.toUpperCase(),
                    }
                )
                .then((res) => {
                    if (res.data.result == 200) {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: "success",
                        });
                        this.dialogVisibles = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
        goddlist() {
            this.$router.push({
                path: "/orderList",
            });
        },
        // 获取用户现金余额、可开票金额
        getUserAccountInfo () {
            this.$axios.post('/cmsMateService/login.do?method=achieveUserInfo', {
                username: sessionStorage.getItem('username')
            }).then(res => {
                if (res.status != 200) { this.$message({ type: 'warning', message: '获取用户信息失败' }) }
                else if (res.data.result != '200') { this.$message({ type: 'warning', message: '获取用户信息失败：' + res.data.message }) }
                else {
                    console.log('获取用户信息成功：', res.data.info)
                    this.cashBalance = res.data.info.balance
                    this.InvoicableAmount = res.data.info.invoiceNum
                    this.endTime = res.data.info.endTime
                    sessionStorage.setItem('endTime', this.endTime)
                    this.remainNum = parseInt(res.data.info.remainNum)
                    sessionStorage.setItem('remainNum', this.remainNum)
                    sessionStorage.setItem('status', parseInt(res.data.info.userType))
                }
            }).catch(() => {
                this.$message({ type: 'warning', message: '获取用户信息异常' })
            })
        },
        // 查询词典释义
        queryWordDefinition () {
            if (this.DictionaryDefinition.word.length == 0) {
                this.$message({ type: 'warning', message: '请先输入查询词' })
                return
            }
            let config = {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
            this.DictionaryDefinition.queryLoading = true
            this.DictionaryDefinition.definition = ''
            // this.$axios.post('https://apis.tianapi.com/lexicon/index', {
            //     key: 'a2db39f2f8ca2ce3063f67ee19b6980f',
            //     word: this.DictionaryDefinition.word
            // }, config).then(res => {
            //     if (res.status !== 200) { this.$message({ type: 'warning', message: '查询词语释义失败' }); this.DictionaryDefinition.definition = '暂无查询结果' }
            //     else if (res.data.code !== 200) { this.$message({ type: 'warning', message: '查询词语释义失败：' + res.data.msg }); this.DictionaryDefinition.definition = '暂无查询结果' }
            //     else {
            //         this.DictionaryDefinition.definition = res.data.result.content
            //     }
            //     this.DictionaryDefinition.queryLoading = false
            // }).catch(() => {
            //     this.$message({ type: 'warning', message: '查询词语释义异常' })
            //     this.DictionaryDefinition.queryLoading = false
            //     this.DictionaryDefinition.definition = '暂无查询结果'
            // })
            this.$axios({
                method: 'post',
                url: 'http://media.webwatch.com.cn:8080/bluefile/frontAPI/WordDefinition',
                headers: {
                    'referer': undefined
                },
                data: {
                    'word': this.DictionaryDefinition.word
                }
            }).then(res => {
                console.log(res)
                if (res.status !== 200) { this.$message({ type: 'warning', message: '查询词语释义失败' }); this.DictionaryDefinition.definition = '暂无查询结果' }
                else if (parseInt(res.data.status) !== 0) { this.$message({ type: 'warning', message: '查询词语释义失败' }); this.DictionaryDefinition.definition = '暂无查询结果' }
                else {
                    this.DictionaryDefinition.pinyin = res.data.result.pinyin
                    this.DictionaryDefinition.content = res.data.result.content
                    this.DictionaryDefinition.example = res.data.result.example
                    this.DictionaryDefinition.jin = res.data.result.jin
                    this.DictionaryDefinition.fan = res.data.result.fan
                }
                this.DictionaryDefinition.queryLoading = false
            }).catch(() => {
                this.$message({ type: 'warning', message: '查询词语释义异常' })
                this.DictionaryDefinition.queryLoading = false
                this.DictionaryDefinition.definition = '暂无查询结果'
            })
        }
    },
    computed: {
        username () { return sessionStorage.getItem('username') },
        userType () { return parseInt(sessionStorage.getItem('status')) },
        // 0系统 1个人 2单位
        userGenre () { return parseInt(sessionStorage.getItem('genre')) },
        openWordDefinition () {
            if (this.userType != 3) return false    // 只有VIP用户可用
            var authInfo = JSON.parse(sessionStorage.getItem('word_definition'))
            if (parseInt(authInfo.state) != 1) return false
            else return true
        }
    },
    mounted() {
        this.user = sessionStorage.getItem("username");
        this.users = sessionStorage.getItem("nickname");
        // this.remainNum = sessionStorage.getItem("remainNum");
        this.lastLogin = sessionStorage.getItem("lastLogin");
        this.endTime = sessionStorage.getItem("endTime");
        this.getData2();
        this.getRecordList();
        this.getUserAccountInfo()
    },
};
</script>

<style lang="less" scoped>
.top-block {
    width: 22%;
    height: 82%;
    padding: 13px;
    text-align: left;
    background: #ffffff78;
    box-shadow: 0px 0px 14px #ccc;
}

h3 {
    margin-bottom: 7px;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
    border-radius: 5px;
    overflow: hidden;
    margin: 10px auto;
    /* // height: 250px; */
    font-family: emoji;
    font-size: 15px;
    /* // border: 2px solid #70aefb; */
    color: #f4f5f7;
    background-color: #328ef4;
}

/deep/#txte .el-dialog__header {
    background: beige;
}

/deep/#tab .el-table th {
    background: rgb(224, 224, 61) !important;
}

/deep/.el-table__header-wrapper {
    background-color: rgba(78, 209, 38, 0.87) !important;
}

table td,
th {
    padding: 3px;
    text-align: center;
    border: 1px solid #f5f7fa75;
    vertical-align: middle;
    font-size: 15px;
    padding: 5px;
    width: 80%;
}

tbody {
    background-color: #328ef4;
}

.table-color-green {
    background-color: green;
}

.table-color-grey {
    background-color: #696969;
}

.table-color-black {
    background-color: black;
}

.shuom {
    color: rgb(255, 255, 255);
    text-decoration: none;
    float: right;
    margin: 10px 2%;
    background-image: linear-gradient(161deg, #57a3f3 0%, #2214ff 100%);
    cursor: pointer;
    padding: 10px 2%;
    border-radius: 5px;
}

.pps p {
    // box-shadow: 0 2px 6px #409eff52, 0 0 2px #409eff52;
    // padding: 10px;
    // box-sizing: border-box;
    font-size: 14px;
    // margin-bottom: 12px;
}

.bgs {
    background-image: linear-gradient(161deg, #2d8cf033 0%, #2214ff 100%);
}

.kaip {
    background-image: linear-gradient(356deg, #f56c6c 0%, rgb(255 195 84) 100%);
}

// .pps p:hover {
//   background: #f9b247;
//   color: #fff;
//   transition: box-shadow 0.3s ease-in-out;
// }
.cidian-item-title {
    background-color: #ccc;
    padding: 3px 10px;
    font-size: 20px;
    text-align: left;
    font-weight: bold;
    color: cadetblue;
    border-radius: .5em;
    margin: 10px 0;
}
.cidian-item {
    text-align: left;
    font-size: 20px;
}

</style>

<style>
.cidian-content {
    text-align: left;
    margin-left: 20px;
}
.cidian-content > li {
    list-style: circle;
}
.cidian-content > li >:first-child {
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/MultiPanel.vue